import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sm-comment-block',
  imports: [CommonModule],
  templateUrl: './comment-block.component.html',
  styleUrl: './comment-block.component.scss',
})
export class CommentBlockComponent {
  @Input() label?: string;
  @Input() comment?: string;
  @Input() date?: string;
  @Input() class?: string;
}
